import { createDefaultTab } from '@sites/entity-core';
import { type NormalizedTabEntity } from '@web/types';
// import { type TabEntity, createDefaultTab } from '@sites/entity-core';

import { getUuid } from '@common/helpers';

export const tabInstance = ({
    parentId,
    children = [],
}: Partial<Pick<NormalizedTabEntity, 'parentId' | 'children'>>): NormalizedTabEntity => {
    const defaultTab = createDefaultTab();

    return {
        ...defaultTab,
        id: getUuid(),
        parentId,
        children,
    };
};
